// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-stepper-vertical-item {
  position: relative;
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-stepper-vertical-item--error {
  color: rgb(var(--v-theme-error));
}
:where(.vuetify-styles) .v-stepper-vertical-item__title {
  font-size: 1rem;
}
:where(.vuetify-styles) .v-stepper-vertical-item__subtitle {
  font-size: 0.75rem;
}
:where(.vuetify-styles) .v-stepper-vertical-item .v-expansion-panel-text {
  padding-inline-start: 32px;
}
:where(.vuetify-styles) .v-stepper-vertical-item:not(:last-child):before {
  content: "";
  position: absolute;
  width: 2px;
  height: calc(100% - 30px);
  background: rgba(var(--v-border-color), var(--v-border-opacity));
  left: 35px;
  top: 44px;
  z-index: 1;
  transition-duration: 300ms;
  transition-property: height;
}
:where(.vuetify-styles) .v-stepper-vertical-item:after {
  display: none;
}
:where(.vuetify-styles) .v-stepper-vertical-item.v-expansion-panel--disabled .v-expansion-panel-title, :where(.vuetify-styles) .v-stepper-vertical-item:not(.v-stepper-vertical-item--editable) .v-expansion-panel-title {
  pointer-events: none;
}
:where(.vuetify-styles) .v-stepper-vertical-item.v-expansion-panel--disabled .v-expansion-panel-title .v-expansion-panel-title__overlay, :where(.vuetify-styles) .v-stepper-vertical-item:not(.v-stepper-vertical-item--editable) .v-expansion-panel-title .v-expansion-panel-title__overlay {
  opacity: 0;
}

:where(.vuetify-styles) .v-stepper-vertical-item__avatar.v-avatar {
  background: rgba(var(--v-theme-surface-variant), var(--v-medium-emphasis-opacity));
  color: rgb(var(--v-theme-on-surface-variant));
  transition-property: background;
  align-self: start;
}
:where(.vuetify-styles) .v-stepper-vertical-item__avatar.v-avatar .v-icon {
  font-size: 0.875rem;
}
:where(.vuetify-styles) .v-expansion-panel--active .v-stepper-vertical-item__avatar.v-avatar {
  background: rgb(var(--v-theme-surface-variant));
}
:where(.vuetify-styles) .v-stepper-vertical-item--error .v-stepper-vertical-item__avatar.v-avatar {
  background: rgb(var(--v-theme-error));
  color: rgb(var(--v-theme-on-error));
}

:where(.vuetify-styles) .v-stepper-vertical-item--error .v-stepper-vertical-item__title {
  color: rgb(var(--v-theme-error));
}

:where(.vuetify-styles) .v-stepper-vertical-item--error .v-stepper-vertical-item__subtitle {
  color: rgb(var(--v-theme-error));
}

:where(.vuetify-styles) .v-stepper-vertical-actions.v-stepper-actions .v-btn {
  margin-inline-end: 8px;
}
:where(.vuetify-styles) .v-stepper .v-stepper-vertical-actions.v-stepper-actions {
  justify-content: flex-end;
  padding: 24px 0 0;
  flex-direction: row-reverse;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VStepperVertical/VStepperVerticalItem.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,wDAAwD;AAC1D;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,gEAAgE;EAChE,UAAU;EACV,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kFAAkF;EAClF,6CAA6C;EAC7C,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;AAC7B","sourcesContent":[".v-stepper-vertical-item {\n  position: relative;\n  transition-duration: 0.2s;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-stepper-vertical-item--error {\n  color: rgb(var(--v-theme-error));\n}\n.v-stepper-vertical-item__title {\n  font-size: 1rem;\n}\n.v-stepper-vertical-item__subtitle {\n  font-size: 0.75rem;\n}\n.v-stepper-vertical-item .v-expansion-panel-text {\n  padding-inline-start: 32px;\n}\n.v-stepper-vertical-item:not(:last-child):before {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: calc(100% - 30px);\n  background: rgba(var(--v-border-color), var(--v-border-opacity));\n  left: 35px;\n  top: 44px;\n  z-index: 1;\n  transition-duration: 300ms;\n  transition-property: height;\n}\n.v-stepper-vertical-item:after {\n  display: none;\n}\n.v-stepper-vertical-item.v-expansion-panel--disabled .v-expansion-panel-title, .v-stepper-vertical-item:not(.v-stepper-vertical-item--editable) .v-expansion-panel-title {\n  pointer-events: none;\n}\n.v-stepper-vertical-item.v-expansion-panel--disabled .v-expansion-panel-title .v-expansion-panel-title__overlay, .v-stepper-vertical-item:not(.v-stepper-vertical-item--editable) .v-expansion-panel-title .v-expansion-panel-title__overlay {\n  opacity: 0;\n}\n\n.v-stepper-vertical-item__avatar.v-avatar {\n  background: rgba(var(--v-theme-surface-variant), var(--v-medium-emphasis-opacity));\n  color: rgb(var(--v-theme-on-surface-variant));\n  transition-property: background;\n  align-self: start;\n}\n.v-stepper-vertical-item__avatar.v-avatar .v-icon {\n  font-size: 0.875rem;\n}\n.v-expansion-panel--active .v-stepper-vertical-item__avatar.v-avatar {\n  background: rgb(var(--v-theme-surface-variant));\n}\n.v-stepper-vertical-item--error .v-stepper-vertical-item__avatar.v-avatar {\n  background: rgb(var(--v-theme-error));\n  color: rgb(var(--v-theme-on-error));\n}\n\n.v-stepper-vertical-item--error .v-stepper-vertical-item__title {\n  color: rgb(var(--v-theme-error));\n}\n\n.v-stepper-vertical-item--error .v-stepper-vertical-item__subtitle {\n  color: rgb(var(--v-theme-error));\n}\n\n.v-stepper-vertical-actions.v-stepper-actions .v-btn {\n  margin-inline-end: 8px;\n}\n.v-stepper .v-stepper-vertical-actions.v-stepper-actions {\n  justify-content: flex-end;\n  padding: 24px 0 0;\n  flex-direction: row-reverse;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
